// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteStatsList_wrapper","stat":"SiteStatsList_stat"};